import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Phpsidebar';
import Button from 'react-bootstrap/Button'
import {Helmet} from "react-helmet";
function Cscomment(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  const right = {
    padding: '0 0 0 '+padding+'rem',
  };

return(
      <div>
      <Sides/>

<Helmet>
 
 <title>Learn Free PHP Comments Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Php comments tutorial for beginners.Comments in Php are only for you to read.If you type any type of contents inside Php comments are ignored by the compiler. CodeExampler provides Multiple Programming Examples for Beginners" />
 <meta name="keywords" content="codeexampler,tutorial for begineers,how to comment php code,php comment section,php comment tag,php comment system,php comment line,php comment syntax,php comment out,php comment multiple lines,Php comments for" />
 <link rel="canonical" href="https://www.codeexampler.com/php-comments" />
 </Helmet>


 <div className='lg:pl-56'>

<h1 className="m-4 mh1">Types Of Comment in Php</h1>
<div className="first">
        <a href="/php-identifier">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-operator">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para">1, Comments in Php use only for a read.<br/>
2, If you type, the compiler ignores any content inside Php comments
</p>
<h2 className="mt-4 mh2">How to comment PHP code</h2>

      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-5"> &#47;* Hello Ram</span>
            {"\n"}
            <span className="qwerty-10">Hello, Bharat */</span>
         
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

<h2 className="mt-4 mh2"> There are two types of comments in a Php programming language.
</h2>
<h3 className="mt-2 mh3">1, Single-line comment<br/>
2, Multi-line comment<br/>
</h3>
<p className="mt-4 para">1, <span className="bold ">Single-line comment</span>-<br/><br/>This single-line comment starts with a &#47;&#47; tag or use # tag and ends at the end of the line.
</p>


<h2 className="headings">Single-line Comments in Php example:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-10"> &#47;&#47; My name is CodeExampler.com</span>
            {"\n"}
            <span className="qwerty-5"> &#47;&#47;This is a Php programming</span>
         
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


<h2 className="headings">Single-line Comments in Php example:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-5"># My name is CodeExampler.com</span>
            {"\n"}
            <span className="qwerty-10">#This is a Php programming</span>
          
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

<p className="mt-4 para">2,<span className="bold"> Multiline Comment</span>-<br/><br/>That is a multi-line comment in Php, and This type of comment must begin with /* and end with */. if you write anything inside this comment, symbols ignore by the compiler</p>



<h2 className="headings">Multiline Comments in Php example:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-10"> &#47;* My name is CodeExampler.com</span>
            {"\n"}
            <span className="qwerty-5">#This is a Php programming*/</span>
            {"\n"}{"\n"}  
          </code>
        </pre>
      </div>


  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/php-identifier">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-operator">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>

        </div>
    </div>
)

}
export default Cscomment;